import styled from "styled-components";

export const TintasContainer = styled.header`
    height: 100vh;
    background-image: url("/img/Toga-Tinta-pc.jpg");
    background-size: cover;
    background-position: center right;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    padding: 0 8%;
    align-items: center;
    justify-content: center;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1;
    }

    p {
        font-size: 50px;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;

        color: transparent;
        -webkit-text-stroke: 1px #fff;

        letter-spacing: 4px;
        z-index: 2;
    }

    @media (max-width: 1024px) {
        background-position: center;
    }

    @media (max-width: 768px) {
        height: 90vh;
        background-position: center top;
        background-image: url("/img/Toga-Tinta-movil.jpg");
        padding: 0 5%;
    }
`;